// QDat special effects and gradients
export const effects = {
  // Blur effects
  blur: {
    light: "blur(10px)",
    medium: "blur(30px)",
    heavy: "blur(120px)",
  },
  // Box shadows
  shadows: {
    card: "0px 18px 40px rgba(112, 144, 176, 0.12)",
    button: "0px 4px 12px rgba(52, 161, 221, 0.4)",
    input: "0px 2px 5px rgba(112, 144, 176, 0.08)",
  },
  // Gradients
  gradients: {
    // Card backgrounds
    cardDark:
      "linear-gradient(127.09deg, rgba(14, 18, 40, 0.94) 19.41%, rgba(10, 14, 33, 0.49) 76.65%)",
    cardLight:
      "linear-gradient(127.09deg, rgba(255, 255, 255, 0.94) 19.41%, rgba(255, 255, 255, 0.49) 76.65%)",

    // Gradient borders
    borderGradient:
      "radial-gradient(69.43% 69.43% at 50% 50%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",

    // Brand gradients
    brand: "linear-gradient(120deg, #34a1dd 0%, #5bbce6 100%)",
    brandGradient:
      "linear-gradient(112.83deg, rgba(52, 161, 221, 0.21) 0%, rgba(52, 161, 221, 0) 110.84%)",
    brandVertical: "linear-gradient(180deg, #34a1dd 0%, #185b7e 100%)",

    // Sidebar gradient
    sidebar:
      "linear-gradient(111.84deg, rgba(14, 18, 40, 0.94) 59.3%, rgba(26, 31, 55, 0) 100%)",

    // Background gradients
    bgGradient:
      "linear-gradient(180deg, rgba(52, 161, 221, 0.06) 0%, rgba(52, 161, 221, 0) 100%)",

    // Status gradients
    success: "linear-gradient(135deg, #22C55E 0%, #16A34A 100%)",
    error: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
    warning: "linear-gradient(135deg, #F97316 0%, #EA580C 100%)",
    info: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
  },
  // Backdrop filters
  backdrop: {
    blur: "backdrop-filter: blur(30px)",
    saturate: "backdrop-filter: saturate(200%) blur(30px)",
  },
  // Glass morphism effects
  glass: {
    dark: "rgba(14, 18, 40, 0.5)",
    light: "rgba(255, 255, 255, 0.1)",
    cardBg:
      "linear-gradient(127.09deg, rgba(14, 18, 40, 0.94) 19.41%, rgba(10, 14, 33, 0.49) 76.65%)",
    borderGradient:
      "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.05))",
    sidebarBg:
      "linear-gradient(111.84deg, rgba(14, 18, 40, 0.94) 59.3%, rgba(26, 31, 55, 0) 100%)",
    activeBg: "#151b37",
    inactiveBg: "#151b37",
  },
}
